const measurementId = "G-MW8P6XRFH4";
const optOutKey = "jeromelecoq.analytics.disabled";
const productionHostnames = new Set([
  "jeromelecoq.com",
  "www.jeromelecoq.com"
]);

const getOptOutPreference = () => {
  const url = new URL(window.location.href);
  const requestedPreference = url.searchParams.get("analytics");

  if (requestedPreference === "off" || requestedPreference === "on") {
    const disabled = requestedPreference === "off";

    try {
      if (disabled) {
        window.localStorage.setItem(optOutKey, "true");
      } else {
        window.localStorage.removeItem(optOutKey);
      }
    } catch (error) {
      // The preference still applies to this page when storage is unavailable.
    }

    url.searchParams.delete("analytics");
    window.history.replaceState(
      window.history.state,
      document.title,
      `${url.pathname}${url.search}${url.hash}`
    );
    return disabled;
  }

  try {
    return window.localStorage.getItem(optOutKey) === "true";
  } catch (error) {
    return false;
  }
};

export const initializeAnalytics = () => {
  const disabled = getOptOutPreference();
  const enabled = productionHostnames.has(window.location.hostname) && !disabled;

  window[`ga-disable-${measurementId}`] = !enabled;

  if (!enabled || document.getElementById("google-analytics-script")) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", measurementId);

  const script = document.createElement("script");
  script.id = "google-analytics-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
};